import { render, staticRenderFns } from "./fvImg.vue?vue&type=template&id=84317c56&lang=pug&"
import script from "./fvImg.vue?vue&type=script&lang=js&"
export * from "./fvImg.vue?vue&type=script&lang=js&"
import style0 from "./fvImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvImg.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvImg.vue
// module id = 158
// module chunks = 0 1